<template>
  <div class="fwwd">
    <div v-for="(item,index) in address" :key="index">
      <p class="lineWord">
        <img src="../../../static/icon/landian.svg" width="12" height="12">
        <span>{{item.Address}}</span>
      </p >
      <div class="card">
        <div class="lineWord " v-for="items in item.gzdz">
        <span style="display:inline-block;vertical-align:middle;width: 90%;">
           {{items.dz}}
        </span>
          <el-button style="float: right;padding:0;vertical-align: middle" @click.native="adres(items)" type="text"><img src="../../../static/icon/weizhi.svg" width="20" height="20"></el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<srcipt src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></srcipt>
<script>

  import {getQueryVariable, weixinInit} from "@/utils";

  export default {
    name: "fuwuwangdian",
    data () {
      return {
        address:[
          {
            Address:'工商银行',
            gzdz: [
              {
                dz: '工商银行北街支行：鸿元丽都楼下',
                wz: [],
              },
              {
                dz: '工商银行中街支行：市政府礼堂隔壁',
                wz: [],
              },
              {
                dz: '工商银行南街支行：老毛纺厂对面',
                wz: [],
              },
              {
                dz: '工商银行西峰新区支行：中元世贸斜对面',
                wz: [],
              },
              {
                dz: '工商银行西峰开发区支行：雄越酒店对面',
                wz: [],
              },
              {
                dz: '工商银行西峰庆化支行：世纪新村楼下',
                wz: [],
              },
              {
                dz: '工商银行庆阳分行营业室：西大街庆阳五中隔壁',
                wz: [],
              },
              {
                dz: '工商银行西峰东街支行：九龙路西峰区政府南侧',
                wz: [],
              },

            ],
          },
          {
            Address:'建设银行',
            gzdz: [
              {
                dz: '建设银行西峰西大街支行：庆阳五中对面',
                wz: [],
              },
              {
                dz: '建设银行西峰西大街支行：庆阳五中对面',
                wz: [],
              },
              {
                dz: '建设银行西峰西大街支行：庆阳五中对面',
                wz: [],
              },
              {
                dz: '建设银行西峰西大街支行：庆阳五中对面',
                wz: [],
              },
              {
                dz: '建设银行西峰西大街支行：庆阳五中对面',
                wz: [],
              },
              {
                dz: '建设银行西峰西大街支行：庆阳五中对面',
                wz: [],
              }
            ]
          },
          {
            Address:'中国银行',
            gzdz: [
              {
                dz: '中国银行庆阳分行营业部：西大街66号',
                wz: [],
              },
              {
                dz: ' 中国银行庆阳西街支行：庆阳宾馆对面',
                wz: [],
              },
              {
                dz: '中国银行北街支行：鸿元丽都楼下',
                wz: [],
              },
              {
                dz: ' 中国银行东街支行：锦龙大厦楼下',
                wz: [],
              },
              {
                dz: ' 中国银行南街支行：市交通局楼下',
                wz: [],
              },
              {
                dz: ' 中国银行庆阳开发区支行：雄越酒店对面',
                wz: [],
              }
            ]
          },
          {
            Address: '邮政储蓄',
            gzdz: [
              {
                dz:'邮政储蓄银行庆阳市北街支行：西峰区北大街56号（鸿元丽都楼下）',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市西街支行：西峰区长庆大道155号（人民银行向南50米）',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市中街营业所：西峰区南大街19号',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市东街支行：西峰区安定东路1号',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市东街营业所：西峰区九龙路28号',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市长庆南路营业所：西峰区长庆大道101号',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市南街支行：西峰区顺化西路1号（雄越酒店南侧）',
                wz: []
              },
              {
                dz:'邮政储蓄银行庆阳市和谐广场支行：西峰区马莲河大道75号（和谐广场西侧）',
                wz: []
              },
          ]

         },
          {
            Address: '甘肃银行',
            gzdz:[
              {
                dz:'甘肃银行庆阳分行营业部 ：世纪广场弘化西路1号',
                wz:[]
              },
              {
                dz:'甘肃银行西峰区支行：九龙路三中隔壁锦龙大厦一楼',
                wz:[]
              },
              {
                dz:'甘肃银行北大街支行：北大街鸿元丽都一楼',
                wz:[]
              },
              {
                dz:'甘肃银行东郊支行：兰州东路东墅一品楼下',
                wz:[]
              },
              {
                dz:'甘肃银行安定路支行：安定东路昊鑫购物广场',
                wz:[]
              },
              {
                dz:'甘肃银行南大街支行：东方丽景茂一楼',
                wz:[]
              },
              {
                dz:'甘肃银行小什字支行：丽景百货一楼',
                wz:[]
              },
              {
                dz:'甘肃银行西郊支行：长庆路汽车西站隔壁',
                wz:[]
              },
              {
                dz:'甘肃银行庆城支行：庆城县北区兴庆路23号',
                wz:[]
              },
              {
                dz:'甘肃银行宁县支行：新宁路1号滨河星城商住楼',
                wz:[]
              },
              {
                dz:'甘肃银行合水支行：子午大道234号',
                wz:[]
              },
              {
                dz:'甘肃银行华池支行：中街10号百汇大厦一楼',
                wz:[]
              },
              {
                dz:'甘肃银行环县支行：文化路58号交通大厦一楼',
                wz:[]
              },
              {
                dz:'甘肃银行正宁支行：正宁县县委对面',
                wz:[]
              },
              {
                dz:'甘肃银行镇原支行：水荫市场综合楼一楼',
                wz:[]
              },
           ]
          },
          {
            Address: '兰州银行',
            gzdz: [
              {
                dz:'兰州银行庆阳分行营业部：长庆路汽车西站对面',
                wz:[]
              },
              {
                dz:'兰州银行庆阳分行营业部：长庆路汽车西站对面',
                wz:[]
              },
              {
                dz:'兰州银行庆阳新区支行：雄越小区楼下',
                wz:[]
              },
            ]
          }

        ]
      }
    },
    created() {
      const companyCode = sessionStorage.getItem('companyCode')?sessionStorage.getItem('companyCode'):getQueryVariable("state")
      weixinInit(companyCode);
      if(!sessionStorage.getItem('theFlag')) {
        sessionStorage.setItem('theFlag',1)
        window.location.reload()
      }
    },
    methods:{
      adres(item){
        wx.ready(()=>{
          wx.openLocation({
            latitude: item.wz[0], // 纬度，浮点数，范围为90 ~ -90
            longitude:item.wz[1], // 经度，浮点数，范围为180 ~ -180。
            name: item.Address, // 位置名
            address: item.gzdz, // 地址详情说明
            scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
          });
        })
      }
    }
  }
</script>

<style scoped>
  .fwwd{
    padding: 10px;
    height: 90%;
    overflow-y: auto;
    font-size: 14px;
    /*font-weight: bold;*/
  }
  .lineWord{
    padding: 12px 5px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f1f1;
  }
  .card{
    background: #fff;
    padding: 8px;
    border-radius: 10px;
  }
  .text_blue{
    color: #0074FF;
  }
  .el-card{
    margin-top: 10px;
    border-radius: 4%;
  }
  .el-divider--horizontal{
    margin-top: 18px;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/xxcx/hzyh.vue